var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imageList
    ? _c(
        "section",
        { staticClass: "image-carousel" },
        [
          _c(
            "carousel",
            {
              attrs: {
                "per-page": 1,
                "pagination-active-color": "#00c896",
                "pagination-color": "rgba(0, 0, 0, 0.1)",
                "pagination-padding": 6,
                "pagination-size": 10,
                "autoplay-timeout": 3000,
                loop: true,
                "autoplay-hover-pause": true,
                autoplay: true
              }
            },
            _vm._l(_vm.imageList, function(image, index) {
              return _c("slide", { key: index }, [
                _c("img", { staticClass: "img-fluid", attrs: { src: image } })
              ])
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3772825b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3772825b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageCarousel.vue
// module id = jPcw
// module chunks = 1